import { render } from "./WorkingCapital.vue?vue&type=template&id=27fe7148&scoped=true"
import script from "./WorkingCapital.vue?vue&type=script&lang=js"
export * from "./WorkingCapital.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=27fe7148&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fe7148"]])

export default __exports__